export const isWhatsappPhoneNumber = (value?: unknown): boolean => {
  const raw = String(value || "").trim();
  return /^\d{7,15}$/.test(raw.replace(/\D/g, "")) && !/[A-Za-z]/.test(raw);
};

export const formatWhatsappRecipient = (
  value?: unknown,
  emptyLabel = "Sin identificador",
): string => {
  const raw = String(value || "").trim();
  if (!raw) return emptyLabel;
  return isWhatsappPhoneNumber(raw)
    ? `+${raw.replace(/\D/g, "")}`
    : `ID ${raw}`;
};
